export default __webpack_public_path__ + "static/media/03.08ffe8e7.jpg";